import { createFileRoute } from '@tanstack/react-router'

import CreateSwastaPage from '@/components/pages/backoffice/_ktg-penyuluh/swasta/_create/containers/CreateSwastaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swasta/create/'
)({
  component: CreateSwastaPage
})
